import React, { useCallback, useEffect, useMemo, useState } from 'react';
import type { NextPage } from 'next';
import Link from 'next/link'
import Image from 'next/image';
import { ImagePreview } from '@douyinfe/semi-ui';

import cName from 'classnames';
import styles from './index.module.scss';

import Wrapper from '@/components/wrapper';
import Pagination from '@/components/seo-pagination';

import request from '@/utils/request';
import { getServerSideProps as _getServerSideProps, getHead } from '@/utils/useHead';

import { useTranslations } from "next-intl";
import { useRouter } from "next/router";


interface IProps {

}
export async function getServerSideProps(context: any) {
  const res: any = await _getServerSideProps(context);
  const { data: cate } = await request.get(`/api/get_gallery_cate`);
  const { data } = await request.get(`/api/get_gallery_list`, {
    params: {
      category_id: context.query.category_id || 0,
      order: context.query.order || 1,
      page: context.query.page || 1,
      rows: 40,
    }
  })
  return {
    props: {
      ...res.props,
      cate: cate?.data || null,
      data: data?.data || null,
    }
  }
}

const Photo: NextPage<IProps> = ({ menuDetail, cate, data }: any) => {
  const router = useRouter();
  const t = useTranslations("media.photo");

  const [previewSrc, setPreviewSrc] = useState('');
  const [previewVisible, setPreviewVisible] = useState(false);

  const previewVisibleChange = useCallback((visible: boolean) => {
    setPreviewVisible(visible);
  }, []);

  return (
    <div>
      <Wrapper>
        <div className={cName(styles.container, 'm-1600')}>
          {getHead(menuDetail)}
          <h2>{t('title')}</h2>
          <div className={styles.head}>
            <ul className={styles.category}>
              <li className={cName(styles.item, { [styles.active]: Number(router.query.category_id) == 0 || !router.query.category_id })}>
                <Link href={`${router.pathname}?category_id=0&order=${router.query.order || 1}&page=${router.query.page || 1}`}>
                  <a>{t('all')}</a>
                </Link>
              </li>
              {
                cate.map((item: any) => (
                  <li
                    key={item.id}
                    className={cName(styles.item, { [styles.active]: router.query.category_id == item.id })}
                  >
                    <Link href={`${router.pathname}?category_id=${item.id}&order=${router.query.order || 1}&page=${router.query.page || 1}`}>
                      <a>{item[`title_${router.locale}`]}</a>
                    </Link>
                  </li>
                ))
              }
            </ul>
            <ul className={styles.sort}>
              <li>
                <Link href={`${router.pathname}?category_id=${router.query.category_id || 0}&order=1&page=${router.query.page || 1}`}>
                  <a className={cName(styles.item, { [styles.active]: Number(router.query.order) == 1 || !router.query.order })}>{t('sort1')}</a>
                </Link>
              </li>
              <li>
                <Link href={`${router.pathname}?category_id=${router.query.category_id || 0}&order=2&page=${router.query.page || 1}`}>
                  <a className={cName(styles.item, { [styles.active]: Number(router.query.order) == 2 })}>{t('sort2')}</a>
                </Link>
              </li>
            </ul>
          </div>
          <div className={styles.list}>
            {
              !!data?.list && data?.list?.map((item: any) => (
                <div key={item.id} className={styles.item}>
                  <img src={item.photo} alt={item[`brief_${router.locale}`]} loading='lazy' onClick={() => {
                    setPreviewSrc(item.photo);
                    previewVisibleChange(true);
                  }} />
                </div>
              ))
            }
          </div>
          <ImagePreview
            src={previewSrc}
            visible={previewVisible}
            onVisibleChange={previewVisibleChange}
          />
          <Pagination
            page={Number(router.query.page || 1)}
            total={data?.total}
            size={data?.list_rows}
          />
        </div>
      </Wrapper>
      <style jsx global>
        {
          `
            .semi-portal{
              z-index: 99999 !important;
            }
            .semi-image-preview-image-img{
              max-width: none !important;
            }
          `
        }
      </style>
    </div>
  );
};

export default Photo;
